import './scripts/common';
import './scripts/common-nav';
import {onFind} from "@elements/init-modules-in-scope";

let _config = window['_config'] || {};
import {translate} from '@elements/translations';
import {findIn, find} from '@elements/dom-utils';


// Todo: Add page specific JS here e.g:
import * as lightbox from '@elements/lightbox';
lightbox.init();

import * as lazyIframe from '@elements/lazy-iframe';
lazyIframe.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({submitOnChange:true,addUrlParams: true});

import * as scrollToTop from './scripts/scroll-to-top';
scrollToTop.init();

import * as tableSort from './scripts/table-sort';
tableSort.init();